import styled from 'styled-components';

import { ReactComponent as Onboarding2 } from '../../assets/img/icons/bluetooth-module-02.svg';
import { ReactComponent as Onboarding3 } from '../../assets/img/icons/bluetooth-module-03.svg';
import { ReactComponent as Onboarding4 } from '../../assets/img/icons/bluetooth-module-04.svg';
import { ReactComponent as Onboarding5 } from '../../assets/img/icons/bluetooth-module-05.svg';
import { ReactComponent as Onboarding6 } from '../../assets/img/icons/bluetooth-module-06.svg';

export const Icon2 = styled(Onboarding2)`
  height: 96px;
  width: auto;
`;

export const Icon3 = styled(Onboarding3)`
  height: 96px;
  width: auto;
`;

export const Icon4 = styled(Onboarding4)`
  height: 96px;
  width: 127px;
  transform: rotate(0);
`;

export const Icon5 = styled(Onboarding5)`
  height: 96px;
  width: auto;
`;

export const Icon6 = styled(Onboarding6)`
  height: 96px;
  width: auto;
`;
